type NamedEntity = { id?: number; name?: string };

export type InstructorAssignmentRow = {
  assignment_summary?: string | null;
  stages?: NamedEntity[];
  grades?: NamedEntity[];
  subjects?: NamedEntity[];
};

function collectNames(row: InstructorAssignmentRow): string[] {
  const groups = [row.stages, row.grades, row.subjects];

  const names: string[] = [];
  for (const group of groups) {
    if (!Array.isArray(group)) continue;
    for (const item of group) {
      const name = String(item?.name ?? "").trim();
      if (name && !names.includes(name)) names.push(name);
    }
  }
  return names;
}

export function formatInstructorAssignmentSummary(
  row: InstructorAssignmentRow,
  isArabic: boolean
): string {
  if (row.assignment_summary?.trim()) {
    return row.assignment_summary.trim();
  }

  const names = collectNames(row);
  if (names.length === 0) {
    return isArabic ? "—" : "—";
  }

  const visible = names.slice(0, 3);
  const separator = isArabic ? "، " : ", ";
  let body = visible.join(separator);
  const remaining = names.length - visible.length;
  if (remaining > 0) {
    body += ` +${remaining}`;
  }

  return body;
}
